function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Tabs } from "../../Tabs";
import { View } from "../../View";
/**
 * Renders a tab UI for use in the `Conversation` screen
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-141}
 */ export function SessionTabs(param) {
    var defaultTab = param.defaultTab, sessionTabs = param.sessionTabs;
    var _useState = _sliced_to_array(useState(defaultTab), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    return /*#__PURE__*/ _jsxs(View, {
        testID: "Session_tabs",
        flex: 1,
        children: [
            /*#__PURE__*/ _jsx(View, {
                style: {
                    // zIndex required to prevent transformed ConversationInner view from covering tabs
                    // when translated up due to ChatInput showing
                    zIndex: 1,
                    paddingTop: 10,
                    backgroundColor: 'white'
                },
                children: /*#__PURE__*/ _jsx(Tabs, {
                    testID: "Conversation_tabs",
                    value: activeTab,
                    onChangeValue: setActiveTab,
                    items: sessionTabs
                })
            }),
            /*#__PURE__*/ _jsx(View, {
                flex: 1,
                children: sessionTabs.filter(function(t) {
                    return t.value === activeTab;
                }).map(function(param, i) {
                    var Component = param.Component;
                    return /*#__PURE__*/ _jsx(View, {
                        row: true,
                        style: {
                            flex: 1,
                            alignItems: 'stretch'
                        },
                        children: Component
                    }, i);
                })
            })
        ]
    });
}
